import locales from '@/components/language/app.js'
var curLang = locales[localStorage.lang_jp]

let host = ''          ///10.255.5.29;   218.17.164.124;  iot.szzt.com.cn
let port = ''             ///1083;           1082;                 11082
let path =''             
let playtag = -1            ///0: 172.16.36.19; 1: iot4dev.szzt.com.cn; 2: iot.szzt.com.cn 3:iot-proxy.szzt.com.cn

//////////////////////// switch
let isdev = 0
// let isdev = 1

if (isdev) {
  host += 'https://iot4dev.szzt.com.cn' // http://10.255.33.141 
  // host += 'http://192.168.2.170:1083' // http://10.255.33.141 
  // host += 'http://42.96.42.165' // 打包暂用
  // host += 'http://localhost' 
  // port = '' // 1083 
  // port = 1083 // 1083 
  playtag = 0
  path = '/csp-api' //csp-api csp
  // path = '/csp-api-test' //csp-api csp
    // path = '/csp' // 打包暂用
} else {
  host += 'http://iot.szzt.com.cn'
  port = '11082'
  playtag = 2
  path = '/csp'
}

export const testPlayType = 0 //0: 证通生产环境，1:证通测试环境，2:印尼
export const playTestAddr = playtag
export const rqsPre = port ? host+':'+port+path : host+path
const sha256 = require("js-sha256").sha256

export default {
  install(Vue) {
    Vue.prototype.$rqsPre = rqsPre
    Vue.prototype.$formlbWidth = '160px' //行控件label宽度
    Vue.prototype.$evWifi = 'S.A1.K3' // wifi硬件版本
    Vue.prototype.$evGPRSWifi = 'S.B1.K3' // wifi+gprs硬件版本
    Vue.prototype.$ev4G = 'ZT4G'
    
    Vue.prototype.$ctrlSize = 'small' //通用控件尺寸
    Vue.prototype.$gRow = 10         //列表请求行数
    Vue.prototype.$showMsgBox = (tip, scb, dcb) => {
      Vue.prototype.$confirm(tip, curLang.app_tip, {
        confirmButtonText: curLang.app_yes,
        cancelButtonText:  curLang.app_no,
        type: 'warning'
      }).then(() => {
        if (scb) scb()
      }).catch(() => {
        if (dcb) dcb()
      })
    }

    Vue.prototype.$sha256 = function (vl) {
      return sha256(sha256(vl+'szzt@002197'))
    }

    Vue.prototype.$pmStore = function (type, name, keys, _this, cb) {
      /// type: set or get
      var datas = {}
      if (type == 'set') {
        keys.forEach(key => {
          datas[key] = _this[key]
        })
        Vue.prototype.$setTmp(name, datas)
      } else {
        /// get
        datas = Vue.prototype.$getTmp(name)
        keys.forEach(key => {
          _this[key] = datas[key]
        })
      }      
      if (cb) {
        cb(datas)
      }
    }
    
    // isdefault merchant st
    Vue.prototype.$isDefaultMc = function (row) {
      if (!row) return false
      if (row.adminStatus === '0') {
        return true
      } else {
        return false
      }
    }
    // isadmin type 
    Vue.prototype.$isAdminType = function () {
      var usr = Vue.prototype.$getTmp('user')
      ////同菜单下，与Admin同权限
      if (usr.roleName === 'Admin') {
        return true
      } else {
        return false
      }
    }
    Vue.prototype.$isNmAdminType = function () {
      var usr = Vue.prototype.$getTmp('user')
      if (usr.roleName === 'Ordinary') {
        return true
      } else {
        return false
      }
    }    
    Vue.prototype.$isProdType = function () {
      var usr = Vue.prototype.$getTmp('user')
      ////同菜单下，与Admin同权限
      if (usr.roleName === 'Production') {
        return true
      } else {
        return false
      }
    }
    // logout
    Vue.prototype.$logoutOp = function (_this) {
      localStorage.token = ''
      _this.$clearTmp()
      _this.$router.replace({ path: '/login' })
    }
    // storage get
    Vue.prototype.$getTmp = function (prop) {
      if (JSON && localStorage.ch_tmp) {
        var obj = JSON.parse(localStorage.ch_tmp)
        if (!obj) {
          return ''
        } else {
          return obj[prop]
        }
      } else {
        return ''
      }
    }
    // storage set
    Vue.prototype.$setTmp = function (key, vl) {
      if (JSON && key) {
        vl = vl ? vl : ''
        var obj = localStorage.ch_tmp
        if (!obj) {
          obj = {}
        } else {
          obj = JSON.parse(obj)
        }
        obj[key] = vl
        localStorage.ch_tmp = JSON.stringify(obj)
      }
    }
    // storage clear
    Vue.prototype.$clearTmp = function () {
      localStorage.ch_tmp = ''
    }
  }
}

